// extracted by mini-css-extract-plugin
module.exports = {"primaryColor":"#0d291c","white":"#fff","container":"styles_container__ZWdvs","link":"styles_link___mThS","selected":"styles_selected__B2fpz"};